module.exports = __webpack_public_path__ + "static/media/industrial_icon.25f25f96.svg";